import React from "react";
import { formatDisplayDate } from "../utils/dateFormat";

const TransactionsViewer = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          color: "#6f6a76",
        }}
      >
        No transactions found
      </div>
    );
  }

  const formatAllocations = (items) => {
    if (!Array.isArray(items) || items.length === 0) {
      return "";
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          width: "100%",
        }}
      >
        {items.map((item, index) => {
          const period = item.StudentFeePeriod;
          const course = period?.Course;

          const month = period?.month;
          const year = period?.year;

          const monthName = month
            ? new Date(2000, month - 1).toLocaleString("en-US", {
                month: "short",
              })
            : "";

          return (
            <div
              key={item.id || index}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
                padding: "7px 10px",
                backgroundColor: "#faf9fd",
                border: "1px solid #e9e6f1",
                borderRadius: "7px",
                fontSize: "12px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  minWidth: 0,
                }}
              >
                <span
                  style={{
                    fontWeight: "600",
                    color: "#4f4a5a",
                  }}
                >
                  {course?.title || item.courseId}
                </span>

                <span
                  style={{
                    color: "#85808f",
                    fontSize: "11px",
                  }}
                >
                  {monthName} {year}
                </span>
              </div>

              <span
                style={{
                  flexShrink: 0,
                  fontWeight: "600",
                  color: "#4d6b5b",
                  backgroundColor: "#bff1db",
                  padding: "4px 8px",
                  borderRadius: "6px",
                  whiteSpace: "nowrap",
                }}
              >
                PKR {Number(item.amountAllocated).toLocaleString()}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const filteredKeys = Object.keys(data[0]).filter(
    (key) =>
      !key.toLowerCase().includes("createdat") &&
      !key.toLowerCase().includes("updatedat") &&
      !key.startsWith("id") &&
      !key.toLowerCase().includes("registrationid") &&
      key !== "items",
  );

  const formatTransactionArray = (value) => {
    if (!Array.isArray(value)) return value;
    return value
      .map((item) => {
        if (item && typeof item === "object") {
          // return `${item.courseId}${item.fee ? ` (${item.fee})` : ""}`;
          return `${item.courseId}`;
        }
        return String(item);
      })
      .join(", ");
  };

  return (
    <div>
      {/* Transaction count */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          backgroundColor: "#d5d1fd",
          borderRadius: "12px",
          padding: "14px 18px",
          marginBottom: "18px",
        }}
      >
        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: "#403b4d",
          }}
        >
          TRANSACTION HISTORY
        </span>

        <span
          style={{
            fontSize: "13px",
            fontWeight: "600",
            color: "#403b4d",
          }}
        >
          {data.length} transaction{data.length !== 1 ? "s" : ""}
        </span>
      </div>

      {/* Table */}
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        }}
      >
        <div
          style={{
            overflowX: "auto",
            width: "100%",
          }}
        >
          <table
            className="table align-middle mb-0"
            style={{
              width: "100%",
              minWidth: "700px",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <thead>
              <tr>
                {filteredKeys.map((key) => (
                  <th
                    key={key}
                    style={{
                      backgroundColor: "#d5d1fd",
                      color: "#000",
                      fontWeight: "600",
                      padding: "14px",
                      textAlign: "center",
                      letterSpacing: "0.5px",
                      fontSize: "13px",
                      borderBottom: "1px solid #e6e6e6",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {key.startsWith("courses")
                      ? "COURSE IDs"
                      : key
                          .replace(/([A-Z])/g, " $1")
                          .replace(/^./, (str) => str.toUpperCase())}
                  </th>
                ))}
                <th
                  style={{
                    backgroundColor: "#d5d1fd",
                    color: "#000",
                    fontWeight: "600",
                    padding: "14px",
                    textAlign: "center",
                    fontSize: "13px",
                  }}
                >
                  FEE COVERAGE
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((transaction, index) => (
                <tr key={index}>
                  {filteredKeys.map((key) => (
                    <td
                      key={key}
                      style={{
                        padding: "14px",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "#444",
                        borderBottom:
                          index === data.length - 1
                            ? "none"
                            : "1px solid #eeeeee",
                        verticalAlign: "middle",
                        wordBreak: "break-word",
                      }}
                    >
                      {Array.isArray(transaction[key]) ? (
                        formatTransactionArray(transaction[key])
                      ) : typeof transaction[key] === "boolean" ? (
                        transaction[key] ? (
                          <span
                            style={{
                              backgroundColor: "#bff1db",
                              borderRadius: "7px",
                              padding: "5px 10px",
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#3f5147",
                            }}
                          >
                            Yes
                          </span>
                        ) : (
                          <span
                            style={{
                              backgroundColor: "#f2c4c4",
                              borderRadius: "7px",
                              padding: "5px 10px",
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#5c4141",
                            }}
                          >
                            No
                          </span>
                        )
                      ) : transaction[key] === null ||
                        transaction[key] === undefined ||
                        transaction[key] === "" ? (
                        <span style={{ color: "#999" }}>—</span>
                      ) : key === "paymentDate" ? (
                        formatDisplayDate(transaction[key])
                      ) : (
                        transaction[key]
                      )}
                    </td>
                  ))}
                  <td
                    style={{ padding: "14px", fontSize: "13px", color: "#444" }}
                  >
                    {formatAllocations(transaction.items)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer */}
      <div
        className="text-end"
        style={{
          marginTop: "10px",
          color: "#777",
          fontSize: "12px",
        }}
      >
        Showing {data.length} of {data.length} transactions
      </div>
    </div>
  );
};

export default TransactionsViewer;
